import { ReactNode } from 'react'

export const richTextOptions = {
  renderText: (text: string): ReactNode => {
    return text
      .split('\n')
      .reduce<ReactNode[]>((children, textSegment, index) => {
        return [...children, index > 0 && <br key={index} />, textSegment]
      }, [])
  },
}
